import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';

const FilterBar = ({ mainFilters, additionalFilters, onClearFilters }) => {
  const [showAdditionalFilters, setShowAdditionalFilters] = useState(false);

  const showModal = () => {
    setShowAdditionalFilters(true);
  };

  const handleCancel = () => {
    setShowAdditionalFilters(false);
  };

  const renderClearButton = () => (
    <button type="button" className="clear-filters" onClick={onClearFilters}>
      <img src="/assets/icons/filters/blue-x.svg" alt="Clear all filters" />
      Clear all
    </button>
  );

  const renderAdditionalFilters = () => {
    if (!additionalFilters) return '';
    return (
      <>
        <button type="button" className="more-filters-toggle" onClick={showModal}>
          <img src="/assets/icons/filters/more-filters.svg" alt="Filters" />
          More filters
        </button>
        <Modal
          title={
            <div className="additional-filters-modal-header">
              <b>All filters</b>
              {renderClearButton()}
            </div>
          }
          visible={showAdditionalFilters}
          onCancel={handleCancel}
          footer={null}
        >
          <div className="additional-filters-modal-content">
            <div className="filter-group-heading">Shown on page</div>
            {mainFilters}
            {additionalFilters ? (
              <>
                <div className="filter-group-heading">Extra filters</div>
                {additionalFilters}
              </>
            ) : (
              ''
            )}
          </div>
        </Modal>
      </>
    );
  };

  return (
    <div className="filter-bar">
      {mainFilters}
      {renderAdditionalFilters()}
      {renderClearButton()}
    </div>
  );
};

FilterBar.propTypes = {
  mainFilters: PropTypes.element,
  additionalFilters: PropTypes.element,
  onClearFilters: PropTypes.any,
};

FilterBar.defaultProps = {
  mainFilters: null,
  additionalFilters: null,
  onClearFilters: null,
};

export default FilterBar;
